import React from 'react';
import { HeaderCloseButton } from './styled';
import { palette } from '../../../styles/_palette';
import { CloseIcon } from '../../../icons';

export const CloseButton: React.FC<{
  onClick: () => void;
  backButtonCypress: string;
}> = ({ onClick, backButtonCypress }) => (
  <HeaderCloseButton
    type="button"
    onClick={onClick}
    aria-label="Close"
    data-cy={backButtonCypress}
  >
    <CloseIcon fill={palette.heatheredGrey} width={15} height={15} />
  </HeaderCloseButton>
);
